function DropDown(el) {
	this.dd = el;
	this.placeholder = this.dd.children('span');
	this.opts = this.dd.find('ul.dropdown > li');
	this.val = '';
	this.index = -1;
	this.initEvents();
}
DropDown.prototype = {
	initEvents : function() {
		var obj = this;

		obj.dd.on('click', function(event){
			$(this).toggleClass('active');
			return false;
		});

		obj.opts.on('click',function(){
			var opt = $(this);
			obj.val = opt.text();
			obj.index = opt.index();
			obj.placeholder.text(obj.val);
          	obj.placeholder.attr('class', opt.attr('class'));
		});
	},
	getValue : function() {
		return this.val;
	},
	getIndex : function() {
		return this.index;
	}
}

$(function() {
	
	var templates_dd_1 = new DropDown( $('#templates_dd_1') );
	var templates_dd_2 = new DropDown( $('#templates_dd_2') );
	var templates_dd_3 = new DropDown( $('#templates_dd_3') );

	$('#templates_dd_1').click(function() {
		// all dropdowns
		$('#templates_dd_2').removeClass('active');
		$('#templates_dd_3').removeClass('active');
	});
	
	$('#templates_dd_2').click(function() {
		// all dropdowns
		$('#templates_dd_1').removeClass('active');
		$('#templates_dd_3').removeClass('active');
	});
	
	$('#templates_dd_3').click(function() {
		// all dropdowns
		$('#templates_dd_1').removeClass('active');
		$('#templates_dd_2').removeClass('active');
	});
});